






import { defineComponent, ref } from '@vue/composition-api';
import { useActions } from 'vuex-composition-helpers';

export default defineComponent({
  setup(props, { emit }) {
    const { deleteAuthority } = useActions(['deleteAuthority']);
    const deleting = ref<boolean>(false);

    return {
      deleting,
      deleteAuthority: async (authorityId: string) => {
        deleting.value = true;
        await deleteAuthority(authorityId);
        deleting.value = false;

        emit('deleted');
      },
    };
  },
});
